<template>
  <div>
    <navigation></navigation>
    <div class="about text-left mx-auto" style="max-width: 900px">
      <h3 class="text-center">Contact</h3>
      <p class="text-center mx-auto">
        <img
          class="rounded-circle mb-5"
          src="@/assets/images/music/oliverdecrow.png"
          width="150px"
          alt="Oliver Borner"
        />
      </p>

      <div class="card" style="width: 100%">
        <div class="card-body">
          <h5 class="card-title">Oliver Borner</h5>
          <p class="card-text">
            <i class="fa fa-envelope-o"></i> oliverborner@gmail.com<br />
            <i class="fa fa-telegram"></i> t.me/OKavalier<br />
          </p>
          <a href="http://www.oliverborner.com/" class="card-link"
            ><i class="fa fa-globe"></i> www.oliverborner.com</a
          >
        </div>
        <div class="card-footer">
          <small class="text-muted"
            ><i class="fa fa-map-marker"></i>
            Dresden, Germany
          </small>
        </div>
      </div>
    </div>
    <br /><br />
  </div>
</template>

<script>
import navigation from "@/components/navigation.vue";
export default {
  components: {
    navigation,
  },
};
</script>

<style lang="scss">
@import "./../sass/_main.scss";
</style>
